"use strict";

angular.module("vendor")
.component("saleRepresentativeEdit", {
    bindings: {
        userVendor: "="
    },
    templateUrl: require("./sale-representative-edit.component.html"),
    controllerAs: "SaleRepresentativeEditSectionCtrl",
    controller: "SaleRepresentativeEditSectionController"
}).controller("SaleRepresentativeEditSectionController", function($scope) {

    $scope.$on("requestResetListing", function($event) {
        $event.preventDefault();
        $scope.$broadcast("resetListing");
    });

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-edit/sale-representative-edit.component.js
// module id = 1002
// module chunks = 0